<template>
  <div class="popup-wrap">
    <div class="border-radius-8 popup-content">
      <div class="bind-wrap">
        <div class="title">{{ $t('lLinkAccount') }}</div>
        <div class="account-list">
          <AccountFunplus :info="bindInfo.funplus_id" @changePopup="handleChangePopup"></AccountFunplus>
          <AccountGoogle :info="bindInfo.google"></AccountGoogle>
          <AccountFacebook :info="bindInfo.facebook"></AccountFacebook>
        </div>
      </div>
      <a href="javascript:;" class="btn-popup-close" @click="$emit('changePopup', { name: '' })"></a>
    </div>
  </div>
</template>

<script>
import AccountFacebook from '../social/AccountFacebook.vue'
import AccountGoogle from '../social/AccountGoogle.vue'
import AccountFunplus from '../social/AccountFunplus.vue'
import { mapMutations } from 'vuex'
export default {
  name: 'Account',
  components: { AccountFacebook, AccountGoogle, AccountFunplus },
  data () {
    return {
      bindInfo: JSON.parse(window.localStorage.getItem('sdkParams') || '{}').bindinfo,
      once_key: undefined
    }
  },
  created () {
    // if (!this.$utils.isQt) this.getBindInfo()
  },
  methods: {
    ...mapMutations({
      setBindInfo: 'setBindInfo'
    }),
    getBindInfo () {
      // this.once_key = this.$utils.getTS()
      // this.$Spin.show()
      // this.$socket.push({
      //   params: {
      //     action: 'get_bind_info',
      //     once_key: this.once_key
      //   },
      //   cb: this.getBindInfoHandler
      // })
    },
    getBindInfoHandler (resp) {
      if (resp.action !== 'get_bind_info' && resp.once_key !== this.once_key) return
      this.$Spin.hide()
      if (resp.code === 0) {
        this.setBindInfo(resp.user_info)
      } else {
        this.$msg.success(resp.code ? this.$t(`KGSDK_${resp.code}`) : this.$t('network_err'))
        this.getBindInfo()
      }
    },
    handleChangePopup (params) {
      this.$emit('changePopup', params)
    }
  }
}
</script>

<style lang='less' scoped >
@import url('@/assets/styles/account.less');
</style>
